// @flow
import * as rootRights from 'app/common/constants/rights/rootRights';
import * as specificRights from 'app/common/constants/rights/specificRights';
import type { RightsPath } from 'app/rights/types';

export const rightsPath: RightsPath = [rootRights.SETTINGS, specificRights.SCHOOL_SETTINGS];
